<dx-popup
  [width]="'90%'"
  [maxWidth]="600"
  [height]="375"
  [showTitle]="true"
  [title]="''"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  [showCloseButton]="true"
  class="modal"
  [classList]="'modal'"
  [visible]="showModal"
  (onHidden)="close()"
>
  <div *dxTemplate="let data of 'content'" class="modal-content">
    <div class="modal-text">
      <h3 class="modal-title">
        {{ 'MY-TRAININGS.SHARE-IDD-NUMBER.TITLE' | translate }}
      </h3>
      <p class="modal-description">
        {{ 'MY-TRAININGS.SHARE-IDD-NUMBER.TEXT' | translate }}
      </p>
    </div>
    <div class="modal-buttons">
      <div class="btn-close-wrapper">
        <dx-button
          class="cta-btn"
          type="default"
          [text]="'COMMON.CLOSE' | translate"
          (click)="close()"
        ></dx-button>
      </div>

      <div class="btn-share-wrapper">
        <dx-button
          class="cta-btn"
          type="normal"
          [text]="'COMMON.SHARE' | translate"
          (click)="shareIddNumber()"
        ></dx-button>
      </div>
    </div>
  </div>
</dx-popup>